import {
  renderTextWithKlarnaLogo,
  renderKlarnaPromotionText,
  type ColorHighlight,
} from '@/components/CycleMsg/klarna-utils';
import { useStore } from '@/providers/app-store-provider';
import { IS_US } from '@/utils/constants';
import { useMemo } from 'react';

export interface KlarnaPromotion {
  enabled?: boolean;
  text_1?: string;
  text_2?: string;
}

/**
 * Z-Klarna支付优惠-20260507
 *
 * 需求文档：
 * https://alidocs.dingtalk.com/i/nodes/ZX6GRezwJl7NdjoEFrN1orodVdqbropQ?utm_scene=team_space
 *
 * 设计稿：
 * https://lanhuapp.com/web/#/item/project/stage?tid=6baa5793-8f5f-47ca-9062-2ada6a07fec3&pid=7c494c6e-4d67-4a95-8050-4bafdf24ab53
 */
export const useKlarnaPaymentPromotion = () => {
  const currencyName = useStore((state) => state.currency.name);
  const jsonvalues = useStore((state) => state.publicResourceData?.jsonvalues);

  return useMemo(() => {
    const raw = jsonvalues?.klarna_promotion;
    const promotion = raw && typeof raw === 'object' ? (raw as KlarnaPromotion) : null;
    const { enabled = false, text_1 = '', text_2 = '' } = promotion || {};
    const isShowKlarnaPromotion = IS_US && enabled === true && currencyName === 'USD';

    const text_1_with_logo = renderTextWithKlarnaLogo(text_1);
    const text_2_with_logo = renderKlarnaPromotionText(text_2);
    const red_text_2_with_logo = renderKlarnaPromotionText(text_2, [
      { match: '$15 off', color: '#E02020' },
    ]);

    return {
      text_1,
      text_1_with_logo,
      text_2,
      text_2_with_logo,
      red_text_2_with_logo,
      isShowKlarnaPromotion,
    };
  }, [currencyName, jsonvalues]);
};
